// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"InfoTooltip_tooltip__3iyLm","tooltipDialog":"InfoTooltip_tooltipDialog__3IUt7","tooltipDialogBox":"InfoTooltip_tooltipDialogBox__1YS2C"};